import { createRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { SignupForm } from "@/components/auth/SignupForm";
import { rootRoute } from "./rootRoute";

export const signupRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/signup",
    component: () => (
        <AuthLayout>
            <SignupForm />
        </AuthLayout>
    ),
});
